var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',_vm._b({staticClass:"rounded-0",attrs:{"flat":"","accordion":"","value":_vm.value},on:{"change":function($event){return _vm.updateValue($event)}}},'v-expansion-panels',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }